<template>
  <div class="fullScreen">
 
    <div  id="container" style="height:600px;"></div>
		<DxPopup
      :visible.sync="paused "
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      title="Paused: Space Toggles"
    >
	
	</DxPopup>
	<DxPopup
      :visible.sync="loadingModel"
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      :title="'Loading Model '+prog+'%'"
    >   
	<DxPosition at="bottom" offset="0 -40"></DxPosition>
    </DxPopup>
		<DxPopup
      :visible.sync="popupVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="300"
      :height="300"
      title="Underwater Demo"
    >
	Drop GLTF Files on Background<br><br>
	
		W:Forward<br>
		A:left<br>
		S:Back<br>
		D:Right<br>
<br>
		R:UP<br>
		F:Down<br>
<br>
		Space:Play/Pause<br>
      
      
    </DxPopup>
	
      <div class="mask" :style="'opacity:1;transform:scale('+maskScale+') translate('+shipLeft+'px,'+maskTop+'px);'">
      <div v-if="debug" class="diveTime">
		  {{position}} 
		  </div>
		  <div v-else class="diveTime">
		DIVE TIME : {{secsToText(diveTime)}} - {{airRemaining}}
		</div>
		<div v-if="true" class="airGague" :style="'width:'+airRemaining+'px;'"></div>
		<div v-if="true" class="airGague rightGague" :style="'width:'+airRemaining+'px;'"></div>
		 <div :style="'position:relative;left:'+(-shipLeft)+'px'">
		<div class="depthGague">
			<div class="depthIndicator" :style="'top:'+(50+Math.floor((3000-position.y)*.01)*5)+'px;'">
				<div class="depthIndicatorValue">{{Math.floor((3000-position.y)*.01)}}m</div>
				</div>
	 		</div>
		<Radar :rotation="rotation" :north="north" :distance="distance"></Radar>
		</div>
		<div class="maskRButtons" :style="'right:'+(-shipLeft)+'px'">
			<div class="AIHolder" style="position:relative;top: -130px;right: 50px; transform: scale(1.4,1.4);opacity:1;">
			 <div class="helpIcon"  @click="showHelp" style=" transform: scale(-1,1);opacity:.7"> </div>
			 <div id="objectPreview"></div>
			  <div v-if="scanned" class="maskInfo">
				<div class="maskInfoLines"></div>
				<div v-html="scanned" ></div>
					<div v-for="(uls1, i) in scenes" :key="'uls1'+i">
				<div v-if="uls1.found" class="unlockBtn" @click="playCutScene(uls1)" ><span v-if="!uls1.watched">scene unlocked<br></span>{{uls1.name}}</div>
				</div>
				</div>
				<div v-if="!scanned" class="maskInfo">
				<div  class="maskInfoLines" ></div>
				<div v-for="(uls, j) in scenes" :key="'uls'+j">
				<div v-if="uls.found" class="unlockBtn" @click="playCutScene(uls)" ><span v-if="!uls.watched">scene unlocked<br></span>{{uls.name}}</div>
				</div>
				</div>
			</div>
			<div  @mouseenter="buttonHover=true" @mouseleave="buttonHover=false">
			<div class="maskBtn surface" @click="backToShip"><div class="MskBtnTxt">SURFACE</div></div>
			<div class="maskBtn laser" @click="laserVision"><div class="MskBtnTxt">VISION</div></div>
			<div v-if="false" class="maskBtn measure"></div>
			<div :class="'maskBtn photo'+selectClass('camera')" @click="selectMode('camera')">
				<div class="MskBtnTxt">PHOTO</div>
				<div class="collectCount" v-if="photos.length>0">{{photos.length}}</div>
		
			</div>
			<div :class="'maskBtn scan'+selectClass('scan')" @click="selectMode('scan')">
				<div class="MskBtnTxt">SCAN</div>
				<div class="collectCount" v-if="scannedItems && Object.keys(scannedItems).length>0">{{Object.keys(scannedItems).length}}</div>
			</div>
			
			<div :class="'maskBtn collect'+selectClass('collectObj')" @click="selectMode('collectObj')">
				<div class="MskBtnTxt">COLLECT</div>
				<div class="collectCount" v-if="Object.keys(collectedItems).length>0">{{Object.keys(collectedItems).length}}</div>
		
			</div>
			</div>
		</div>
		
		<div :class="'maskMode '+modeSelected">
			<div id="objectPreviewX"></div>
			<div v-if="modeSelected" class="maskModeCenter" @click="doMode" @mousedown="hoverModeDown" @mouseover="hoverMode" @mouseleave="hoverModeOut">
				<div v-if="scanned && false" class="scanText" v-html="scanned"></div>
			</div>
		</div>
		
		<div v-show="showPhoto" class="photoImage" @click="showPhoto=false" :style="'position:absolute;left:0px;transform:rotate('+photoRot+'deg);'">
			<div id="photo"  :width="800" :height="600" >  </div>
         
		</div>
		
	</div>
	<div v-show="vidSrc" class="projector" >
		<div :style="'position:relative;margin:auto;width:'+(projectorWidth)+'px;height:'+(projectorHeight)+'px;top:'+projectorTop+'px;'">
			<video   @click="pauseVideo" ref="previewVid" :style="'opacity:'+1+';pointer-events:auto;position:ralative;'" 
				width="100%" type="video/mp4" :src="vidSrc" autoplay>
			</video>
			<div  @click="closeVideo" class="vidClose">x</div>
			<div class="CTA" ref="CTAU"> 
			
				<div @click="closeVideo" class="closeCut">Close Video</div>
				<div class="vidMessage">Click the wall switch in the lighthouse to view the story so far.</div>
			
			</div>
		</div>
	</div>
  </div>
</template>

<script>

var paused=true
var loadingModel=false

import gsap from "gsap";
import Radar from "@/components/Radar"
import screen from "@/mixins/screen"
import Help from '@/mixins/help'
export default {
	mixins:[ screen,Help],
   	components: {
		   DxPopup,DxPosition,DxAt,DxOffset,
		   Radar
  },

		data: () => ({
			buttonHover:false,
			scenes:{
				SCN001:{id:"SCN001",name:"The Gunner",watched:false,found:false,path:"bomber%2FBeaufort-Gunner.mp4"},
				SCN002:{id:"SCN002",name:"The Long Swim",watched:false,found:false,path:"bomber%2FBeaufort-drown.mp4"},
				SCN003:{id:"SCN003",name:"The Horse",watched:false,found:false,path:"bermagui%2FBermagui_Loading.mp4"},
				SCN004:{id:"SCN004",name:"Overboard",watched:false,found:false,path:"bermagui%2FBermagui_Animals.mp4"},
				SCN005:{id:"SCN005",name:"Depth Charge",watched:false,found:false,path:"sub%2FM28Sub_Depth.mp4"},
				SCN006:{id:"SCN006",name:"Missfire",watched:false,found:false,path:"sub%2FM28Sub_FailedTorp.mp4"},
		
			},
			warningShown:false,
			unlockedScene:null,
			imageWidth:1920,
			imageHeight:1080,
			photoRot:2,
			modeSelected:null,
			scanned:null,
			collected:null,
			showPhoto:false,
			popupVisible: false,
			paused:false,
			loadingModel:false,
			position:{x:0,y:2500,z:0},
			rotation:0,
			distance:0,
			north:0,
			rotInfo:0,
			lvOn:false,
			waterColor:'#226666',
			diveStart:null,
			diveTime:1,
			date:null,
			fallPos:100,
			
			prog:0,
			objects:{},
			waterConditions:{
				waterColor:"#226666",
				showRays:false,
				ambientLight:1,
				directionLight:1,
				diveLight:1,
				diveLightRange:1000,
				oceanBottom:500
			},
			waterConditionsX:{
				waterColor:"#566287"
			},
			mouseX:0,
			modelPath:null,
			vidPath:null,
			vidSrc:null,
			
			 helps:[	
        		{id:"H009_divestart",showOnce:true,shown:false,help:{}},
				{id:"H010_diveControl",showOnce:false,shown:false,help:{}},
				{id:"H011_collecting",showOnce:false,shown:false,help:{}},
				{id:"H401",showOnce:false,shown:false,help:{}},
				{id:"H402",showOnce:false,shown:false,help:{}}
			]
			
		}),
		
		mounted(){
			this.warningShown=false
			vueApp=this
			this.modelPath = this.fireBaseLoc+"wrecks%2F"
			this.vidPath = this.fireBaseLoc+"wrecks%2F"
			 this.$store.commit("setSettingsClass","settingsIcon dive")
			if(!this.wrecks){
       			this.$store.dispatch("loadWrecks")
       			return
    		}
			//this.unlockedScene=this.scenes.SCN002
			this.loadArtefacts()
			
			console.log("WRECK",this.wreck)
			this.startScene()
			
			
		},
		computed:{
			getHelpState(){
				return this.$store.getters.getHelp
			},
			fireBaseLoc(){
				return this.$store.getters.getFireBaseLoc					
			},
			fireBaseWrecks(){
				return this.$store.getters.getFireBaseWrecks
			},
			diveStartPos(){
				let diveStartPos={x:0,y:0,z:0}
				
				if(this.wreck && this.wreck.divePos){
					
						let posD=this.wreck.divePos.split(",")
						
						diveStartPos.x=parseInt(posD[0],10)
						diveStartPos.y=parseInt(posD[1],10)
						diveStartPos.z=parseInt(posD[2],10)
						
					}
						return diveStartPos
					
			},
			projectorWidth(){
				return 1920*this.containScale(1920,1080)*.8;
			},
			projectorHeight(){
				return 1080*this.containScale(1920,1080)*.8;
			},
			projectorTop(){
				return Math.floor((this.windowHeight-this.projectorHeight)*.5)
			},
			
			debug(){
				return this.$store.getters.getDebug
			},
			activeWreckStatus(){
				console.log("ACTIVE WRECK STATUS",this.activeWreck)
				if(this.activeWreck){
					console.log("ACTIVE WRECK STATUS",this.$store.getters.getActiveWreckStatus)
					return this.$store.getters.getActiveWreckStatus
				}else{
					return null
				}		
			},
			unlockedScenes(){
				
				console.log("unlockedScenes",this.wreckStatus)
				if(this.activeWreckStatus){
					if(!this.activeWreckStatus.scenes){
						this.activeWreckStatus.scenes=[]
					}
					return this.activeWreckStatus.scenes
				}else{
					return null
				}
				
			},	
			isTester(){
				return this.$store.getters.getIsTester
			},
			wrecks(){
     			return this.$store.getters.getWrecks
			},
			activeWreck(){
				if(this.gameStatus){
					console.log("ACTIVE WRECK",this.gameStatus,this.gameStatus.activeWreck)
					return this.gameStatus.activeWreck
				}
				return null
			},
			gameStatus(){
				console.log("gameStatus",this.$store.getters.getGameStatus)
				return this.$store.getters.getGameStatus
			},
			artefacts(){
				return this.$store.getters.getArtefacts
			},
			scannedItems(){
				return this.$store.getters.getScannedItems
			},
			collectedItems(){
				return this.$store.getters.getCollectedItems
			},
			photos(){
				return this.$store.getters.getPhotos
			},
			airRemaining(){
				let maxAir=500
				let step=9.5
				
				return Math.round((Math.max(1,maxAir-this.diveTime+14)/maxAir*388+20)/step)*step
			},
			 diveModel(){
				 return this.$store.getters.getDiveModel
			 },
			 wreck(){
				 console.log("GET WRECK",this.$store.getters.getWreck)
				 
      			return this.$store.getters.getWreck
			},
			depthM(){
				return Math.floor((3000-position.y)*.01)
			},
			shipLeft(){
       return this.coverLeft(this.imageWidth,this.imageHeight)
    },
    maskTop(){
       return this.coverTop(this.imageWidth,this.imageHeight)
    },
    maskScale(){
      return this.coverScale(this.imageWidth,this.imageHeight)
    },
		},
		methods:{
			loadArtefacts(){
				if(this.wreck){
				for(var a in this.wreck.artefacts){
        			this.$store.dispatch('loadArtefact',this.wreck.artefacts[a].split(" ")[0])
            	}
				
				}else{
					
					gsap.delayedCall(1,this.loadArtefacts)
				}
			},
			addWreckEvi(evi){
				console.log("ADD Wreck EVI - ",evi,this.activeWreckStatus)
				if(this.activeWreckStatus && this.activeWreckStatus.diveEvi){
					if(!this.activeWreckStatus.diveEvi[evi.id]){
						this.activeWreckStatus.diveEvi[evi.id]=evi
					}
				}
				console.log("ADD Wreck EVI",evi,this.activeWreckStatus)
			},
			startScene(){
				this.setConditions()

			console.log("Underwater Running")
			this.loadTheWreck()
			//fogColour="#FF0000"
			this.setWater()
			init();
			isRunning=true
			animate();
			requestAnimationFrame( this.checkStatus );
			document.addEventListener('keyup', this.keyUp);
			
			this.date=new Date()
			this.diveStart=this.date.getTime();
			window.addEventListener('mousemove', this.mouseMove);
			
			gsap.delayedCall(2,this.showHelp)
			},
			setConditions(){
				if(this.wreck && this.wreck.diveConditions){
				let DC
				for(var dc in this.wreck.diveConditions){
					DC=this.wreck.diveConditions[dc].split(":")
					
					this.waterConditions[DC[0]]=DC[1]
					console.log(this.waterConditions)
				}
				// FLoaties
				let floatyDensity=1
				if(this.waterConditions.floaties){
					floatyDensity=parseFloat(this.waterConditions.floaties,10)
				}
				
				floaties = new Floaties(3,floatyDensity)
				
				
				
				this.waterConditions.oceanBottom=parseInt(this.waterConditions.oceanBottom,10)
			}
			},
			mouseMove(event){
				this.mouseX=Math.abs(window.innerWidth*.5-event.clientX)
				/*if(this.mouseX>window.innerWidth*.4){
					controls.lookSpeed=Math.max(0.,controls.lookSpeed-.002)
				}else{
					controls.lookSpeed=Math.min(0.05,controls.lookSpeed+.002)
				}*/
				
			},
			setWater(){
				// very foggy fog 1,1000
				// distant fog 1500,3000
				this.waterColor=this.waterConditions.waterColor || "#226666"
				fogColour=this.waterColor
				fogNear=this.waterConditions.fogNear || 1
				fogFar=this.waterConditions.fogFar || 2000
				showRays=this.waterConditions.showRays || false
				ambientLight=this.waterConditions.ambientLight
				directionLight=this.waterConditions.directionLight
				diveLight=this.waterConditions.diveLight
				diveLightRange=this.waterConditions.diveLightRange

				
				
			},
			secsToText(sec){
				let mins="0 Min"
				let secs=sec%60
				if(sec>120){
					mins=Math.floor(sec/60)+"Min"
				}else if(sec>60){
					mins="1 min"
				}
				if(secs==1){
					secs=" 01 Sec"
				}else if(secs<10){
					secs=" 0"+secs+" Sec"
				}else{
					secs=" "+secs+" Sec"
				}
				return mins+secs
			},
			hoverMode(event){
				
				//
			},
			hoverModeDown(event){
				
				paused=true
			},
			hoverModeOut(event){
				
				if(!this.getHelpState){
					paused=false
				}
			},
			doMode(event){
				event.preventDefault();
				paused=true
				console.log("DO MODE")
				switch(this.modeSelected){
					case "camera":
						this.takePic()
						break;
					case "scan":
						this.scanObj()
						break;
					case "collectObj":
						this.collectObj()
						break;
				}
			},
			selectMode(btn){
				if(this.modeSelected==btn){
					this.modeSelected=null
				}else{
					this.modeSelected=btn
				}
				
			},
			selectClass(btn){
				if(this.modeSelected==btn){
					return " selected"
				}else{
					return ""
				}
			},
			scanObj(){
				checkObject()
			},
			collectObj(){
				takeObject()
			},
			takePic(){
				this.photoRot=Math.random()*6-3
				waitingForPic=true
			},
			laserVision(){
				this.lvOn=!this.lvOn
				if(!this.lvOn){
					renderer.toneMappingExposure = Math.pow( 1, 4.0 );
					bloomPass.threshold = Number( 0 );
					bloomPass.strength = Number( 0 );
					bloomPass.radius = Number( 0);
					scene.fog.color.set(this.waterColor);
					scene.background.set(this.waterColor);
				}else{
					renderer.toneMappingExposure = Math.pow( 1.4, 4.0 );
					bloomPass.threshold = Number( 0.5 );
					bloomPass.strength = Number( 1 );
					bloomPass.radius = Number( 1.95);
					scene.fog.color.set('#300909');
					//scene.fog.color.set('#030909');
					scene.background.set('#030909');
				}
				/*
					exposure=1.7
					bloomStrength=1
					bloomRadius=1.95
					fogColor=#300909

				*/
				setWireFrame(this.lvOn)
			},
			backToShip(){
				 this.$store.dispatch('startTransition',{text:"Back on the surface",to:"ship",from:"dive"})
			},
			loadTheWreck(){
				//no spaces

				loadingModel=true
				let shipPathX
				let wreck=this.wreck
				if(this.diveModel){
						shipPathX=this.diveModel
				}else if((this.wreck && this.wreck.model) ){
					
					shipPathX=this.modelPath+this.wreck.model
					

				}else{
					
					shipPathX=this.fireBaseLoc+"wrecks%2Fbomber%2FBEAUFORT%20BAKED%202048.gltf?alt=media&token=c42c9289-45cf-4674-bff5-cad0b1a6a7fc"
				}
				console.log("loading ",shipPathX)
				const loaderX = new GLTFLoader();
				let cname
				loaderX.load(shipPathX, gltf => {

					gltf.scene.traverse( child => {
						if ( child.material ) {
							//child.material.wireframe=true
							child.material.metalness = 0;
							
							cname=child.name.toUpperCase()
							if(cname.indexOf("ARTEFACT")>-1){
								console.log(cname)
								aObjects.push(child)
							}else if(cname.indexOf("GROUP")==-1 && cname.indexOf("CORAL")==-1 && cname.indexOf("CRRAL")==-1 && cname.indexOf("COARL")==-1 &&  cname.indexOf("SEAWEED")==-1 && cname.indexOf("ROC")==-1 && cname.indexOf("SAND")==-1 && cname.indexOf("GROUND")==-1 && cname.indexOf("TERRAIN")==-1){
								aObjects.push(child)
								console.log(child.name)
							}else{
								
								child.material.color== new THREE.Color(0,0,0)
							}
						}
					})
					loadingModel=false;
					if(wreck && wreck.modelPos){
						
						let pos=wreck.modelPos.split(",")
						gltf.scene.position.x=parseInt(pos[0],10)
						gltf.scene.position.y=parseInt(pos[1],10)
						gltf.scene.position.z=parseInt(pos[2],10)
					}else{
						
					}
					
					scene.add(gltf.scene);
					floaties.setFall(0)
					this.fallToBottom()
					paused=false
					if(vueApp.wreck && vueApp.wreck.modelScale){
						gltf.scene.scale.set(vueApp.wreck.modelScale,vueApp.wreck.modelScale,vueApp.wreck.modelScale)
					}
						loadedModel=gltf
					},
					this.loadProg,this.loadError)
				
			},
			fallToBottom(){
				this.fallPos=this.position.y
				gsap.to(this,5,{fallPos:-this.diveStartPos.y,onUpdate:this.doFall})
			},
			closeVideo(){
				this.vidSrc=null
				gsap.to(this.$refs.CTAU,1,{autoAlpha:0})
			},
			pauseVideo(){
				
					console.log("pause video")
					this.$refs.previewVid.pause()
					gsap.to(this.$refs.CTAU,1,{autoAlpha:1})
				
			},
			videoEnded(){
				console.log("VIDEO ENDED")
				gsap.killTweensOf(this)
				gsap.to(this,1,{vidOpacity:.1})
				gsap.to(this.$refs.CTAU,1,{autoAlpha:1})
			},
			recordScene(scene){
				if(!this.unlockedScenes.includes(scene)){
					this.unlockedScenes.push(scene)	
					this.$store.dispatch('saveGameState')
				}
			},
			doFall(){
				camera.position.x=this.diveStartPos.x
				
				camera.position.z=this.diveStartPos.z
				camera.position.y=this.fallPos
			},
			playCutScene(scene){
				this.vidSrc=this.fireBaseWrecks+scene.path
				scene.watched=true
				console.log("UnlockedScene",scene)
				vueApp.$refs.previewVid.onended = function() {
						vueApp.videoEnded()
				};
				
			},
			
			checkStatus(){
				if(isRunning){
					if(this.airRemaining<80 && !this.getHelpState && !this.warningShown){
						
						this.$store.dispatch("showBasicHelp","Air running low Return to surface")
						this.warningShown=true
						//this.backgroundColor
					}else if(this.airRemaining<20){
						this.$store.dispatch("showBasicHelp","Low Air Returning to surface")
						this.backToShip()
						//returnToSurface
					}
				 	this.date=new Date()
				 	this.diveTime= Math.floor((this.date.getTime()-this.diveStart)/1000)+14
					this.loadingModel=loadingModel
					this.position.x=Math.floor(position.x)
					this.position.y=Math.floor(position.y)
					this.position.z=Math.floor(position.z)
					this.north=rotation
					this.rotInfo=rotation
					this.distance=Math.floor(Math.sqrt(position.x*position.x+position.z*position.z))
					this.rotation=Math.floor(Math.atan2(position.z - 0, position.x - 0) * 180 / Math.PI-90)
					if(Math.floor((3000-position.y)*.01)<2){
						this.backToShip()
					}else{
						requestAnimationFrame( this.checkStatus );
					}
					if(collected && !scanFound){
						scanFound=true
						let name = collected.name.split("_")[1] || collected.name
						
						console.log("TRY COLLECT",name,collected.name,this.artefacts)
						if(this.artefacts[name] && this.artefacts[name].collectable=="true"){
							if(!this.collectedItems[name]){
								this.collectedItems[name]=this.artefacts[name]
							}
							removeCollected()
						}else{
							if(this.artefacts[name] && this.artefacts[name].collectable && this.artefacts[name].collectable!="false"){
								this.$store.dispatch("showBasicHelp",this.artefacts[name].collectable)
							}else{
								this.$store.dispatch("showBasicHelp","You can't collect that")
							}
							collected=null
						}
					}
					if(!scanned){
						this.scanned=null
					}
					if(scanned && !scanFound){
						scanFound=true
						//console.log(scanned.name.split("_").shift())
						let name = scanned.name.split("_")[1] || scanned.name
						
						
						console.log("SCANNED",name,this.artefacts)
						if(this.artefacts[name]){
								this.scannedItems[name]=this.artefacts[name]
								this.scanned=this.artefacts[name].name
								console.log("NEW SCAN Added",name,this.scanned,this.artefacts[name],this.artefacts[name].materials.indexOf("----"))
								if(this.artefacts[name].materials && this.artefacts[name].materials.indexOf("----")==-1){
									this.scanned+="<br>Material:"+this.artefacts[name].materials
									console.log("Material",this.artefacts[name],this.artefacts[name].materials)
								}
								if(this.artefacts[name].dimensions && this.artefacts[name].dimensions.substr("----")==-1){
									this.scanned+="<br>Dimensions:"+this.artefacts[name].dimensions
								}
								if(this.artefacts[name].details){
									this.scanned+="<br>"+this.artefacts[name].details
								}
								if(this.artefacts[name].cutScene && !this.artefacts[name].shown){
									console.log("CUT SCENE",this.scenes,this.artefacts[name].cutScene)
									this.scenes[this.artefacts[name].cutScene].found=true
									this.recordScene(this.scenes[this.artefacts[name].cutScene].path)
									this.artefacts[name].shown=true
									
								}
								if(this.artefacts[name].evidence){
									gsap.delayedCall(2,this.reportEvidence,[this.artefacts[name].evidence])
									//this.$store.dispatch("showBasicHelp",this.artefacts[name].evidence.split(":")[1])
								}
								
							
						}else{
							console.log("Scanning ",scanned.name)

							console.log(this.scannedItems)
							let sName=scanned.name.split("_")[0]
							if(scanned.name.split("_")[0]=="BOAT" || scanned.name.split("_")[0]=="WRECK"){
								sName=scanned.name.split("_")[0]+"_"+scanned.name.split("_")[1]
							}
							let scanObj=this.$store.getters.getMaterial({wreck:this.activeWreck,name:sName})
							
							this.scanned=scanObj.name
							if(scanObj.materials){
									this.scanned+="<br>Material:"+scanObj.materials
								}
								if(scanObj.evidence){
									gsap.delayedCall(2,this.reportEvidence,[scanObj.evidence.toString()])
								}
							console.log(this.scanned)
							//this.scanned="UNKNOWN "+scanned.name
						}
						
					}else{
						
						//this.scanned=null
					}
				}
				
			},
			reportEvidence(evidence){
				console.log("Report Evidence",evidence )
				let eviObj={id:evidence.split(":")[0],text:evidence.split(":")[1]}
				this.addWreckEvi(eviObj)
				this.$store.dispatch("showBasicHelp",eviObj.text)
			},
			loadError(e){
				console.error(e)
			},
			loadProg(p){
				
				this.prog=Math.floor(p.loaded/p.total*100)
				position.x=this.diveStartPos.x
				position.z=this.diveStartPos.z
				position.y=Math.min(2600,2000-this.prog*20+this.diveStartPos.y+500)
				//console.log("Loading "+this.prog+"% ",position.y)
			},
		keyUp(e){
				switch(e.key){
					case " ":
						console.log("pause")
						this.paused=!this.paused
						paused=this.paused
						break
					case "x":
						this.selectMode('scan')
						break
					case "p":
						this.selectMode('camera')
						break
					case "z":
						this.selectMode('camera')
						break
					case "c":
						this.selectMode('collectObj')
						break
					case "v":
						this.laserVision()
						break	
					case "w":
						this.paused=false
						break
				
				}
			}
	   
		},
		watch:{
			
			getHelpState(val){
				console.log("HELP",val)
				if(val){
					paused=true
				}else{
					paused=false
				}
			},
			debug(val){
				if(val){
					if(vueApp.isTester){
						gsap.set(gui.domElement,{autoAlpha:1})
					}
					container.appendChild( stats.dom );
				}else{
					gsap.set(gui.domElement,{autoAlpha:0})
					container.removeChild( stats.dom );
				}
			},
			activeWreck(val){
				 console.log("=======ACTIVE WRECK===== Wrecks",val)
				if(val){
					this.$store.commit('setWreckByName',this.activeWreck)
		   			this.loadArtefacts()
           			this.startScene()
				}
			},
			 wrecks(val){
          console.log("============ Wrecks",val)
          if(this.activeWreck){
		   this.$store.commit('setWreckByName',this.activeWreck)
		   this.loadArtefacts()
           this.startScene()
          }
	   },
	   airRemaining(val){
		   console.log("Air Remaining",val)
	   },
	   
			wreck(val){
				for(var a in val.artefacts){
        			this.$store.dispatch('loadArtefact',val.artefacts[a].split(" ")[0])
      			}
				//this.startScene()
			}
		},
		beforeDestroy(){
			document.removeEventListener('keyup', this.keyUp,false);
			window.removeEventListener('mouseMove', this.mouseMove,false);
			isRunning=false
			if ( gui ) gui.destroy();
		}
	};



			import * as THREE from 'three';

			import Stats from 'three/examples/jsm/libs/stats.module.js';
			import * as dat from 'dat.gui';
			import { DxPopup,DxPosition,DxAt, DxOffset } from 'devextreme-vue/popup';
			import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
			import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
			import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
			import { BloomPass } from 'three/examples/jsm/postprocessing/BloomPass.js';
			
			import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
			import { FilmPass } from 'three/examples/jsm/postprocessing/FilmPass.js';
			import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js';
			import { DotScreenShader } from 'three/examples/jsm/shaders/DotScreenShader.js';
			import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass.js';
			import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader.js';
			
			import { MaskPass, ClearMaskPass } from 'three/examples/jsm/postprocessing/MaskPass.js';
			import { TexturePass } from 'three/examples/jsm/postprocessing/TexturePass.js';

			import { BleachBypassShader } from 'three/examples/jsm/shaders/BleachBypassShader.js';
			import { ColorifyShader } from 'three/examples/jsm/shaders/ColorifyShader.js';
			import { HorizontalBlurShader } from 'three/examples/jsm/shaders/HorizontalBlurShader.js';
			import { VerticalBlurShader } from 'three/examples/jsm/shaders/VerticalBlurShader.js';
			import { SepiaShader } from 'three/examples/jsm/shaders/SepiaShader.js';
			import { VignetteShader } from 'three/examples/jsm/shaders/VignetteShader.js';
			import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js';
			
import * as Nodes from 'three/examples/jsm/nodes/Nodes.js';
import {ImprovedNoise} from 'three/examples/jsm/math/ImprovedNoise.js';
			import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
			//import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls.js';
			import { FirstPersonControlsTouch } from 'three/examples/jsm/controls/FirstPersonControlsTouch.js';
			import { Floaties } from '../assets/scripts/objects/Floaties'
import { Vector3 } from 'three';


			var fogColour='#226666'
			var fogNear=0
			var fogFar=2000
			var showRays=true
			var ambientLight,directionLight,diveLight,diveLightRange
			var scene
			var isRunning =true
			var position={x:0,y:0,z:0}
			var rotation=0
			var waitingForPic=false
			//
			var scanFound=false
			var vueApp
			var camera, scene, renderer, composer;
			var object, light,Alight;
			var spotLight,floaties
			var bloomParams
			var bloomPass
			var container
			var controls
			var params
			var clock = new THREE.Clock();
			var stats,gui
			var effect,effect2,effect3,effect4
			var loadedModel
			var lightRays
			var aObjects=[]
			//
			var mesh,texture, worldWidth = 1024, worldDepth = 1024,
		  	worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
			//init();
			//animate();
			const scene2= new THREE.Scene();
			var container2
			var camera2
			var meshS2
			var scanned,collected
			const renderer2 = new THREE.WebGLRenderer({ alpha: true });
			function init() {
				console.log("INIT")
				container = document.getElementById( 'container' );
				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );
				//document.body.appendChild( renderer.domElement );

				//

				camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 1, 3000 );
				
				camera.position.z = 100;

				scene = new THREE.Scene();
				
				//
				if(scene){
					scene.add(floaties.particles);
				}
				console.log("pre scene 2")
				container2 = document.getElementById( 'objectPreview' );
				
				renderer2.setPixelRatio(1);
				renderer2.setSize( 400, 400 );
				renderer2.setClearColor( 0xffffff, 0);
				container2.appendChild( renderer2.domElement );
				 meshS2 = new THREE.Group();
				const fov = 45;
				const near = 0.1;
    			const far = 5;
   				camera2 = new THREE.PerspectiveCamera(fov, 1, near, far);
				//camera2 = new THREE.PerspectiveCamera( 70, 1, 1, 1000 );
				const colorS2 = 0xFFFFFF;
				const intensityS2 = 1;
				const lightS2 = new THREE.DirectionalLight(colorS2, intensityS2);
				lightS2.position.set(-1, 2, 4);
				scene2.add(lightS2);
				
				scene2.add(camera2);
				camera2.position.set(0, 1, 2);
    			camera2.lookAt(0, 0, 0);
				scene2.add(meshS2);
				meshS2.position.set(0,0,0)
				renderer2.render(scene2, camera2);
				

				//cone
				var texture = new THREE.TextureLoader().load(require( '../assets/images/rays2.png' ));
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping;
				texture.repeat.set( 6, 1 );
				var geometry = new THREE.CylinderGeometry( 800,3200, 6500, 32,2,true );

				var material = new THREE.MeshPhysicalMaterial( {
					color: 0xffffff,
					metalness: 1,
					roughness: 1,
					side : THREE.DoubleSide,
					//alphaTest: 1,
					flatShading:false,
					emissive:0xffffff,
					emissiveIntensity:10,
					depthWrite: false,
					transparency: .9, // use material.transparency for glass materials
					opacity: 1,                        // set material.opacity to 1 when material.transparency is non-zero
					transparent: true,
					//map: texture,
					alphaMap: texture 
				} );
				lightRays = new THREE.Mesh( geometry, material );
				lightRays.position.set(0,0,0)
				scene.add( lightRays );


			var centerGuideMaterial = new THREE.MeshPhysicalMaterial( {
					color: 0xffffff,
					metalness: 1,
					roughness: 1,
					emissive:0xffffff,
					emissiveIntensity:10				
				} );
				var centerGuide = new THREE.CylinderGeometry( 10,10, 100, 32,2,true );
				var centerGuideMesh = new THREE.Mesh( centerGuide, centerGuideMaterial );
				centerGuideMesh.position.set(0,0,0)
				//scene.add( centerGuideMesh );



				controls = new FirstPersonControlsTouch( camera, document );
				//controls = new FirstPersonControls( camera, renderer.domElement );
				controls.movementSpeed = 100;
				controls.lookSpeed = 0.05;

				
				Alight = new THREE.AmbientLight( 0x222222 ); // soft white light
				Alight.intensity=ambientLight || 1;
        		scene.add( Alight );
                scene.fog = new THREE.FogExp2( 0x226666, 0.0005);
			
				light = new THREE.DirectionalLight( 0xffffff );
				light.position.set( 1, 1, 1 );
				light.intensity=directionLight || 1
				scene.add( light );
				// SpotLight       
				spotLight = new THREE.SpotLight( 0xffffff);
				spotLight.intensity=diveLight || 1;
				spotLight.angle = Math.PI / 6;
				spotLight.penumbra =.5;
				spotLight.distance = diveLightRange || 1000;
				scene.add( spotLight );
				camera.add( spotLight.target );
				spotLight.target.position.set( 0, 0, -1 );
				
				//processing
				bloomParams = {
				exposure: 1,
				bloomStrength: 0,//4.5,
				bloomThreshold: 0,
				bloomRadius: 0 
			}
				

				//Stats
		stats = new Stats();
		//container.appendChild( stats.dom );
		// GUI
	
		createGUI()
				composer = new EffectComposer( renderer );
				composer.addPass( new RenderPass( scene, camera ) );
				const loader = new GLTFLoader();
				loader.setCrossOrigin( 'anonymous' );
			//
			var effectSobel = new ShaderPass( SobelOperatorShader );
				effectSobel.uniforms[ 'resolution' ].value.x = window.innerWidth * window.devicePixelRatio;
				effectSobel.uniforms[ 'resolution' ].value.y = window.innerHeight * window.devicePixelRatio;
				effectSobel.enabled = false;
			composer.addPass( effectSobel );

			bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
			bloomPass.threshold = bloomParams.bloomThreshold;
			bloomPass.strength = bloomParams.bloomStrength;
			bloomPass.radius = bloomParams.bloomRadius;
			composer.addPass( bloomPass );

			effect = new ShaderPass( VergilWaterShader );
			effect = new ShaderPass( VergilWaterShader );
            effect.uniforms['centerX'].value = 0.8;
            effect.uniforms['centerY'].value = 0.8;
            composer.addPass( effect );
            effect2 = new ShaderPass( VergilWaterShader );
            effect2.uniforms['centerX'].value = 0.2;
            effect2.uniforms['centerY'].value = 0.2;
            composer.addPass( effect2 );
            effect3 = new ShaderPass( VergilWaterShader );
            effect3.uniforms['centerX'].value = 0.2;
            effect3.uniforms['centerY'].value = 0.8;
            composer.addPass( effect3 );
            effect4 = new ShaderPass( VergilWaterShader );
            effect4.uniforms['centerX'].value = 0.8;
            effect4.uniforms['centerY'].value = 0.2;
            effect4.renderToScreen = true;
            composer.addPass( effect4 );
			

			window.addEventListener( 'resize', onWindowResize, false );

			}
			
			function loadModel(gltfPath,options){
				loadingModel=true
		// Model Loader
		console.log("PATH",gltfPath)
		const loader = new GLTFLoader();
		// all files referenced in the gltf file have now also been resolved by your loaders.
		loader.load(gltfPath, gltf => {
		//const loadedScene = gltf.scene || gltf.scenes[0];
		loadedModel=gltf
		const clips = gltf.animations || [];
			// called when the resource is loaded
			if(options.position){
				gltf.scene.position.set(options.position[0],options.position[1],options.position[2])
			}
			if(options.trace){
				gltf.scene.traverse( child => {
					
					if ( child.material ) {
						child.material.color = new THREE.Color(0,.5,0)
						child.material.emissive=new THREE.Color(0,.5,0)
						child.material.emissiveIntensity = 0
						child.material.roughness =1
						child.material.envMapIntensity = 0
					}
					
				} );
			}
			if(options.fixMetal){
				gltf.scene.traverse( child => {
					if ( child.material ) child.material.metalness = 0;
				} );
			}
			if(options.scale){
				if(options.scale.length>1){
					gltf.scene.scale.set(options.scale[0],options.scale[1],options.scale[2])
				}else{
					gltf.scene.scale.set(options.scale,options.scale,options.scale)
				}
			}
			if(options.onLoad){
				options.onLoad(gltf.scene,gltf.animations)
			}else{
				loadingModel=false
				console.log("LOADED",gltf)
				scene.add( gltf.scene );
				
			
			}
		},
		( xhr ) => {
			// called while loading is progressing
			console.log( `${( xhr.loaded / xhr.total * 100 )}% loaded` );
		},
		( error ) => {
			// called when loading has errors
			loadingModel=false
			console.error( 'An error happened', error );
		});
	}
			function setRays(val){
				if(val){
					scene.add(lightRays)
				}else{
					scene.remove(lightRays)
				}
			}
			function setWireFrame(val){
				
				if(loadedModel){
					loadedModel.scene.traverse( child => {
					if ( child.material ) {
						
						child.material.wireframe=val
						console.log(child.name)
						
					}else{
							for(var ch in child.children){
							if ( child.material ) {
								console.log(child.children[ch].name)
								child.children[ch].material
								child.children[ch].material.wireframe=val
							}
						}
					}
				})
				}
			}	
			function onWindowResize() {
				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();
				renderer.setSize( window.innerWidth, window.innerHeight );
				composer.setSize( window.innerWidth, window.innerHeight );

			}

			function animate() {
				if(isRunning ){
					 requestAnimationFrame( animate );
					
						 update()
					 
					
				}
			}
			function cropPlusExport(img,cropWidth,cropHeight){
				// create a temporary canvas sized to the cropped size
				var canvas1=document.createElement('canvas');
				canvas1.classList.add('photoCanvas')
				var ctx1=canvas1.getContext('2d');
				canvas1.width=cropWidth;
				canvas1.height=cropHeight;
				var imgS = new Image;
				//console.log(cropX,cropY,cropWidth,cropHeight)
				imgS.onload = function(){
					//ctx1.drawImage(imgS,cropX,cropY,cropWidth,cropHeight,0,0,cropWidth,cropHeight);
  					ctx1.drawImage(imgS,Math.floor(imgS.width*.5-cropWidth),Math.floor(imgS.height*.5-cropHeight),cropWidth*2,cropHeight*2,0,0,cropWidth,cropHeight); // Or at whatever offset you like
				};
				console.log("SAVE PHOTO1")
				if(vueApp.$store.getters.user){
					console.log("SAVE PHOTO2")
					vueApp.$store.dispatch("savePhoto",img).then((res)=>{
						
					})
				}else{
					vueApp.photos.push(img)
				}
				imgS.src = img;
				

				// use the extended from of drawImage to draw the
				// cropped area to the temp canvas
				//ctx1.drawImage(imgS,cropX,cropY,cropWidth,cropHeight,0,0,cropWidth,cropHeight);
				// return the .toDataURL of the temp canvas
				console.log("building it")

				document.getElementById('photo').appendChild(canvas1);
				vueApp.showPhoto=true
				
				return(canvas1.toDataURL());
			}
		function removedScanned(){
			if(scanned){
				meshS2.remove(scanned)
				scanned=null
				vueApp.$store.dispatch('saveGameState')
			}
		}	
		function takeObject(){
			scanFound=false
			var mouse3D = {x: 0, y: 0};//new THREE.Vector3( 0,  0,   1 );     
			
			var raycaster =  new THREE.Raycaster(); 
			console.log("mouse3D",mouse3D,camera.position)  
			                                 
			raycaster.setFromCamera( mouse3D, camera );
            var intersects = raycaster.intersectObjects( aObjects );

            if ( intersects.length > 0 ) { 
				console.log("FOUND IT ",intersects[0].object)
				if(intersects[0].object.name.indexOf("ARTEFACT")>-1 || intersects[ 0 ].object.name.toLowerCase().indexOf("hitarea")>-1 ){
					if(intersects[ 0 ].object.name.toLowerCase().indexOf("hitarea")>-1){
						collected=intersects[0].object.parent
						console.log("Collect the parent",collected)
					}else{
						collected=intersects[0].object
					}
					vueApp.$store.dispatch('saveGameState')
				}
			}
		}
		function removeCollected(){
			console.log("TAKE COLLECTED")
			if (collected){
				collected.remove(...collected.children)
				collected.parent.remove(collected)
				collected=null
			}
		}
        function checkObject( ) { 
			scanFound=false  
			
            
            //var mouse3D = new THREE.Vector3( camera.position.x,   camera.position.y,   camera.position.z+1 );     
			var mouse3D = {x: 0, y: 0};//new THREE.Vector3( 0,  0,   1 );     
			
			var raycaster =  new THREE.Raycaster(); 
			console.log("mouse3D",mouse3D,camera.position)  
			                                 
			raycaster.setFromCamera( mouse3D, camera );
            var intersects = raycaster.intersectObjects( aObjects );

            if ( intersects.length > 0 ) { 
				console.log("FOUND IT ",intersects[0].object)
				//intersects[ 0 ].object.material.color.setHex( Math.random() * 0xffffff );
				//intersects[ 0 ].object.material.color.setHex(0xffffff );
				
				//intersects[ 0 ].object.material.wireframe=true
				if(scanned){
					removedScanned()
				}
				
				if(intersects[ 0 ].object.name.toLowerCase().indexOf("hitarea")>-1){
					console.log("HIT AREA",intersects[ 0 ].object.parent)
					scanned=intersects[ 0 ].object.parent.clone()
				}else{
					scanned=intersects[ 0 ].object.clone()
				}
				
				
				if(scanned.name.indexOf("ARTEFACT")>-1){
				
					console.log("SCANNED",scanned, vueApp.artefacts)
					meshS2.add(scanned)
					scanned.position.set(0,0,0)
					scanned.rotation.set(0,0,0)
					var box = new THREE.Box3().setFromObject( scanned );
					var ms=new THREE.Vector3( 0,  0,    ); 
					box.getSize(ms)
					var scanSize=1.2/Math.max(ms.x,Math.max(ms.y,ms.z))
					scanned.scale.set(scanSize,scanSize,scanSize)
					
					//console.log("SCANNED",scanned.material)
					if(scanned.material){
						scanned.material=scanned.material.clone();
						scanned.material.emissiveIntensity=.6
						scanned.material.emissive.setHex(0x3399ff)
					}else{
						for(var ci in scanned.children ){
							if(scanned.children[ci].material){
								scanned.children[ci].material=scanned.children[ci].material.clone();
								scanned.children[ci].material.emissiveIntensity=.6
								scanned.children[ci].material.emissive.setHex(0x3399ff)
							}
						}
						
					}
					
				//intersects[ 0 ].object.material.emissive.setHex(0x339933)
				//scanned.position.set(camera.position.x,camera.position.y,camera.position.z);
				}
				setTimeout(removedScanned,7000)
            }
		}	

			function update() {
				if(vueApp && vueApp.buttonHover){
					controls.lookSpeed=Math.max(0.,controls.lookSpeed-.002)
				}else{
					controls.lookSpeed=Math.min(0.05,controls.lookSpeed+.002)
				}
				//console.log("DIVE",camera.position.y,vueApp.waterConditions.oceanBottom)
				camera.position.y=Math.max(camera.position.y,parseInt(vueApp.waterConditions.oceanBottom,10))
				
				 position=camera.position
				 //rotation=-Math.floor(camera.rotation.z/Math.PI*180)
				
				var dir = new THREE.Vector3();
				var sph = new THREE.Spherical();
				camera.getWorldDirection(dir);
  				sph.setFromVector3(dir);
				rotation=(sph.theta-180)/Math.PI*180
				 // camera.getWorldDirection(dir);
				  
				
				if(gui && params.waterDistort){
				effect.uniforms['time'].value += Math.random();
				effect2.uniforms['time'].value += Math.random();
				effect3.uniforms['time'].value += Math.random();
				effect4.uniforms['time'].value += Math.random();
				}
				var time = performance.now() * 0.001;
				var deltaTime=clock.getDelta()
				floaties.update(time)
				floaties.particles.position.y=camera.position.y;
				spotLight.position.copy( camera.position );
				lightRays.position.copy( camera.position );
				meshS2.rotateY(.01)
				//lightRays.position.set(camera.position.x,0,camera.position.z)
				if(!paused && !vueApp.vidSrc && !vueApp.showPhoto){
					controls.update( deltaTime );
				}

				stats.begin();

	// monitored code goes here

	stats.end();
				composer.render();
				renderer2.render(scene2, camera2);
				if(waitingForPic){
					waitingForPic=false
					var data=renderer.domElement.toDataURL("image/jpeg")
					var croppedURL=cropPlusExport(data,720,540);
					var image = new Image();
					image.src = croppedURL;
					//console.log(data)
					//vueApp.$store.dispatch("savePhoto",data)
					//document.getElementById('photo').appendChild(image);
				
				}
				
			}
		function createGUI(){
		// GUI
		
		if ( gui ) {
			 try{
				gui.destroy();
			}
			catch(err){
			}	
		}
		
	class FogGUIHelper {
    		constructor(fog, backgroundColor) {
      			this.fog = fog;
      			this.backgroundColor = backgroundColor;
    		}
			get near() {
				return this.fog.near;
			}
			set near(v) {
				this.fog.near = v;
				this.fog.far = Math.max(this.fog.far, v);
			}
			get far() {
				return this.fog.far
			}
			set far(v) {
				this.fog.far = v;
				this.fog.near = Math.min(this.fog.near, v);
			}
			get color() {
				return `#${this.fog.color.getHexString()}`;
			}
			set color(hexString) {
				this.fog.color.set(hexString);
				this.backgroundColor.set(hexString);
			}
		}						
  	
		var color = fogColour;
		
		const near = 1;
		const far = 5000;
		scene.fog = new THREE.Fog(color, fogNear, fogFar);
		scene.background = new THREE.Color(color);
		const fogGUIHelper = new FogGUIHelper(scene.fog, scene.background);
		setRays(showRays)
  
		gui = new dat.GUI();
		var fogOptions={
			color:scene.fog.color
		}
		
		params={
			showWireFrame:false,
			waterDistort:false,
			showRays:showRays
		}
		var folder = gui.addFolder( 'Global Light' );
		folder.add( Alight, 'intensity', 0, 4, .1 ).name( 'Ambient Light' );
		folder.add( light, 'intensity', 0, 4, .1).name( 'Direction Light' );
		var folderSL = gui.addFolder( 'Divers Spotlight' );
		folderSL.add( spotLight, 'intensity', 0, 10, 1 ).name( 'Intensity' );
		folderSL.add( spotLight, 'angle', 0, 1, .1 ).name( 'Angle' );
		folderSL.add( spotLight, 'penumbra', 0, 1, .1 ).name( 'Penumbra' );
		folderSL.add( spotLight, 'distance', 0, 5000, 10 ).name( 'Range' );
		var folderFog = gui.addFolder( 'Fog' );
		folderFog.add(fogGUIHelper, 'near', near, far).listen();
   		folderFog.add(fogGUIHelper, 'far', near, far).listen();
		folderFog.addColor(fogGUIHelper, 'color');
		var folderProcessing = gui.addFolder( 'Effects' );
		
		folderProcessing.add( params, 'waterDistort' ).name("Distort")
		folderProcessing.add( params, 'showRays' ).onChange( function ( value ) {
			setRays(value)
		} );
		folderProcessing.add( params, 'showWireFrame' ).onChange( function ( value ) {
			setWireFrame(value)
		} );
		folderProcessing.add( bloomParams, 'exposure', 0.1, 2 ).onChange( function ( value ) {
			renderer.toneMappingExposure = Math.pow( value, 4.0 );
		} );
		folderProcessing.add( bloomParams, 'bloomThreshold', 0.0, 1.0 ).onChange( function ( value ) {
			bloomPass.threshold = Number( value );
		} );
		folderProcessing.add( bloomParams, 'bloomStrength', 0.0, 3.0 ).onChange( function ( value ) {
			bloomPass.strength = Number( value );
		} );
		folderProcessing.add( bloomParams, 'bloomRadius', 0.0, 5.0 ).step( 0.01 ).onChange( function ( value ) {
			bloomPass.radius = Number( value );
		} );

	gui.close()
	if(!vueApp.isTester){
		gsap.set(gui.domElement,{autoAlpha:0})
	}
			//folder.open();
		//
	}
	//
const VergilWaterShader = {

	uniforms: {
		"tDiffuse": { type: "t", value: null },
		"time":     { type: "f", value: 0.0},
		"distort_speed": {type: "f", value: 0.0005},
		"distortion":   { type: "f", value: 0.08 },
		//"distort_speed": {type: "f", value: 0.0005},
		//"distortion":   { type: "f", value: 0.04 },
		"centerX": {type: "f", value: 0.5},
		"centerY": {type: "f", value: 0.5},
	},

	vertexShader: [

	"varying vec2 vUv;",
	"void main() {",
		"vUv = uv;",
		"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

	"}"

	].join("\n"),

	fragmentShader: [

	"uniform sampler2D tDiffuse;",
	"uniform float time;",
	"uniform float distort_speed;",
	"uniform float distortion;",
	"uniform float centerX;",
	"uniform float centerY;",
	"varying vec2 vUv;",

	"void main() {",
		"vec2 p = vUv;",
		"vec2 center_coord;",
		"float distance_to_center;",
		"float projected_distance_to_center;",
		"float distort_degree;",

		"center_coord.x = p.x - centerX;",
		"center_coord.y = p.y - centerY;",
		"distance_to_center = sqrt(center_coord.x * center_coord.x + center_coord.y * center_coord.y);",
		"distort_degree = abs( mod(distort_speed* time, distortion) - (distortion / 2.0)) + 1.0;",
		"projected_distance_to_center = pow(1.0, distort_degree - 1.0) * pow(distance_to_center/1.0, distort_degree);",
		"p.x = projected_distance_to_center * center_coord.x/ distance_to_center + centerX;",
		"p.y = projected_distance_to_center * center_coord.y/ distance_to_center + centerY;",
		"vec4 color = texture2D(tDiffuse, p);",
		"gl_FragColor = color;",

	"}"


	].join("\n")

};
		</script>

<style>
body{
		overflow: hidden;
		-webkit-touch-callout: none;
		user-select: none; 
		-webkit-user-select: none; 
}
.photoCanvas{
		position:absolute;
		top:0px;
		left:0px;
	}
	
</style>
<style scoped>
.fullScreen{
		width:100%;
		height:100%;
    position:relative;
    background-color: #000;
    overflow:hidden;
    
  }
  
.basicBtn:hover{
  background-color:#fff3;
}

  .diveTime{
	  position: absolute;
    top: 153px;
    left: 720px;
    color: #00ffffc9;
    font-weight: bold;
    text-align: left;
  }
	.mask{
		transform-origin: top left;
		top:0px;
		width:1920px;
		height:1080px;
		position:absolute;
		pointer-events:none;
		background-image:url("../assets/images/ship/mask2.png");
		background-position:50% 50%;
		background-size:cover;
	}
	.depthGague{
		position:absolute;
		left:20px;
		top:120px;
		width:150px;
		height:300px;
		pointer-events: auto;
		transform:scale(.8);
		background-image:url("../assets/images/ship/maskDepthGague.png");
	}
	.depthIndicator{
		position:absolute;
		left:7px;
		top:100px;
		width:70px;
		height:5px;
		background-color: orange;
	}
	.depthIndicatorValue{
		margin-left:80px;
		top: -10px;
		position: relative;
		color: #19c1c5;

	}
	.maskRButtons{
		position:fixed;
		right:10px;
		top:0px;
		bottom:0px;
		width:150px;
		height:700px;
		margin:auto;
		pointer-events: auto;
		transform:scale(.8)
	}
	.maskBtn{
		width:150px;
		height:100px;
		opacity:.8;
		background-image:url("../assets/images/ship/maskBtns.png");
		margin-bottom:10px;
		cursor:pointer;

	}
	.maskBtn:hover{
		opacity:1;
	}
	.maskBtn.selected{
		opacity:1;
	}
	.maskBtn.selected:hover{
		opacity:1;
	}
	.collectCount{
		left: 58px;
    top: 44px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #45fff7;
    color: #000;
    font-size: 20px;
    font-weight: 500;
    position: relative;
    opacity: 0.6;
	}
	.maskBtn.surface{background-position:0px 5px;}
	.maskBtn.laser{background-position:0px -100px;}
	.maskBtn.measure{background-position:0px -200px;}
	.maskBtn.photo{background-position:0px -300px;margin-top:100px;}
	.maskBtn.scan{background-position:0px -400px;}
	.maskBtn.collect{background-position:0px -500px;}
	.maskMode{
		position:absolute;
		left:0px;
		right:0px;
		top:0px;
		bottom:0px;
		width:640px;
		height:480px;
		margin:auto;
		
		
	}
	.airGague{
		position:absolute;
		width:408px;
		height:226px;
		bottom:-55px;
		right:1061px;
		transform-origin: top right;
		transform: rotate(18.8deg) ;
		background-position: 100% 0%;
		background-image:url("../assets/images/ship/maskAir2.png");
	}
	.rightGague{
		right:873px;
		transform:scale(-1,1) rotate(18.8deg) ;
	}
	.MskBtnTxt{
		position: relative;
		width: 156px;
		font-size: 25px;
		top: 32px;
		text-align: center;
		color: #fff;
	}
	.maskModeCenter{
		position:absolute;
		width:100px;
		height:100px;
		
		left:0px;
		right:0px;
		top:0px;
		bottom:0px;
		margin:auto;
		pointer-events: auto;
	}
	.maskMode.camera{background-image:url("../assets/images/ship/modeCamera.png");}
	.maskMode.scan{background-image:url("../assets/images/ship/modeScan.png");}
	.maskMode.collectObj{background-image:url("../assets/images/ship/modeCollect.png");}
	.photoImage{
		position:absolute;
		left:0px;
		right:0px;
		width:720px;
		height:540px;
		top:0px;
		bottom:0px;
		margin:auto;
		border:solid 3px #fff;
		box-shadow: #000000 0px 0px 30px;
		transform:rotate(2deg);
		pointer-events:auto;
	}
	.scanText{
		position: absolute;
		top: 100px;
		left: -90px;
		width: 300px;
		text-align: left;
		color: #45fff7;
		font-size: 20px;
		text-shadow: #000 0px 0px 5px;
		opacity: 0.8;
    /* background-color: #fff;*/
	}
	#objectPreviewX{
		width:400px;
		height:400px;
		left:0px;
		right:0px;
		top:0px;
		bottom:0px;
		margin:auto;
		position:absolute;
		opacity:0.8
	}
	#objectPreview{
		transform: scale(0.7);
    width: 400px;
    height: 400px;
    right: 0px;
    top: 80px;
    margin: auto;
    position: absolute;
    opacity: 1;
	}
	.maskInfo{
    text-shadow: black 0px 0px 8px;
    color: #06dbff;
    position: absolute;
    text-align:right;
    top: 100px;
    font-weight: 500;
    font-size: 18px;
    right: 100px;
	 min-width: 210px;
    text-transform: uppercase;
    z-index: 2;
    pointer-events: none;
}
.maskInfoLines{
  position: absolute;
    right: -10px;
    top: -50px;
    width: 40px;
    height: 40px;
    border-top: #06dbff solid 2px;
    border-left: #06dbff solid 2px;


}
.unlockBtn{
	  pointer-events:auto;
	  color:orange;
  	margin: 10px auto;
	  min-width: 210px;
    cursor: pointer;
    border: solid;
   text-align:center;
    border-radius: 5px;
    padding: 0px 5px;
    border-top: none;
    border-bottom: none;
}
.vidClose{
	position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
	color:#fff;
	font-size:18px;
  }
  .vidClose:hover{
    background-color: #3e3e3e;
  }
.projector{
		position:absolute;
		top:0px;
		bottom:0px;
		left:0px;
		right:0px;
		width:100%;
		background-color:#00000033;
		/*background: linear-gradient(#75818333 3px, #777777aa 1px);*/
		background-size: 100% 5px;
		margin:0px auto;
	}	
.CTA{
		position:absolute;
		visibility:hidden;
		opacity:0;
		width:100%;
		height:100%;
		top:0px;
		color:#fff;
		background-color: #000000aa;
	}
	.CTA h2{
		margin-top:20%
	}
	.CTA button{
		padding: 10px;
    margin: 10px;
    border-radius: 5px;
    font-family: "Orbitron";
	}
	.vidMessage{
		color: #fff;
		position: absolute;
		padding-top:20px;
		font-size:15px;
		height: 1px;
		opacity: .5;
		left: 0px;
		right: 0px;
		top: 50px;
		bottom: 0px;
		margin: auto;
		
	}
	.closeCut{
		color: #fff;
		position: absolute;
		height: 22px;
		padding: 7px;
		opacity: .7;
		left: 0px;
		width: 146px;
		border: #fff 1px solid;
		border-radius: 10px;
		right: 0px;
		top: 0px;
		bottom: 0px;
		margin: auto;
		cursor:pointer;
	}
	.closeCut:hover{
		opacity: .9;
	}	
</style>